
import { FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from "@/components/ui/select";
import { Control } from "react-hook-form";
import { FormValues } from "./types";

interface ConditionSelectProps {
  control: Control<FormValues>;
}

export function ConditionSelect({ control }: ConditionSelectProps) {
  return (
    <FormField
      control={control}
      name="condition"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Condizione</FormLabel>
          <Select onValueChange={field.onChange} defaultValue={field.value}>
            <FormControl>
              <SelectTrigger>
                <SelectValue placeholder="Seleziona condizione" />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              <SelectItem value="above">Sopra</SelectItem>
              <SelectItem value="below">Sotto</SelectItem>
            </SelectContent>
          </Select>
          <FormDescription>
            Avvisami quando il prezzo va sopra/sotto l'obiettivo
          </FormDescription>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
